import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { ReviewFlowDataResult } from "@ServerTypes/reviewflows/reviewflows.schema";
import type { ReviewDataResult } from "@ServerTypes/reviews/reviews.schema";

const reviewFlowDataSlice = createSlice({
  name: "reviewFlowData",
  initialState: {} as Partial<ReviewFlowDataResult>,
  reducers: {
    setReviewFlowData: (_state: Partial<ReviewFlowDataResult>, action: PayloadAction<Partial<ReviewFlowDataResult>>) =>
      action.payload,
  },
});

const reviewFlowResourceTypeSlice = createSlice({
  name: "reviewFlowResourceType",
  initialState: "RESOURCE_TYPE_FILE",
  reducers: {
    setReviewFlowResourceType: (_state: string, action: PayloadAction<string>) => action.payload,
  },
});

const reviewDataSlice = createSlice({
  name: "reviewData",
  initialState: {} as ReviewDataResult,
  reducers: {
    setReviewData: (_state: ReviewDataResult, action: PayloadAction<ReviewDataResult>) => action.payload,
  },
});

export const { setReviewFlowData } = reviewFlowDataSlice.actions;
export const { setReviewFlowResourceType } = reviewFlowResourceTypeSlice.actions;
export const { setReviewData } = reviewDataSlice.actions;

export const reviewFlowData = reviewFlowDataSlice.reducer;
export const reviewFlowResourceType = reviewFlowResourceTypeSlice.reducer;
export const reviewData = reviewDataSlice.reducer;

export default reviewFlowDataSlice.reducer;
